import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 8h1c1.258 0 2.47.333 3.533.956a7.03 7.03 0 012.51 2.51A6.971 6.971 0 0146 15c-.026 3.36-.026 7.362 0 12.012.018 3.177-.13 6.508-.443 9.993a7 7 0 01-6.493 6.357c-6.548.449-11.55.674-15.013.674-3.467 0-8.497-.225-15.098-.675a7 7 0 01-6.496-6.37A113.73 113.73 0 012 27.017V15c0-1.258.333-2.47.956-3.534a7.03 7.03 0 012.51-2.51A6.972 6.972 0 019 8h1V7a3 3 0 016 0v1h16V7a3 3 0 116 0v1zm-.171 2a3.001 3.001 0 01-5.659 0H15.83a3.001 3.001 0 01-5.66 0H9c-.9 0-1.764.238-2.523.682a5.03 5.03 0 00-1.795 1.795A4.972 4.972 0 004 15v12.018c0 3.128.15 6.394.449 9.797a5 5 0 004.64 4.55c6.56.447 11.55.67 14.962.67 3.409 0 8.37-.222 14.876-.669a5 5 0 004.638-4.54c.307-3.423.452-6.69.435-9.803a914.22 914.22 0 010-12.027c0-.899-.238-1.761-.682-2.519a5.03 5.03 0 00-1.795-1.795A4.972 4.972 0 0039 10h-1.171zm-2.83-4a1 1 0 00-1 1v2a1 1 0 102 0V7a1 1 0 00-1-1zM13 6a1 1 0 00-1 1v2a1 1 0 002 0V7a1 1 0 00-1-1zm-2 12a1 1 0 00-1 1v16a1 1 0 001 1h26a1 1 0 001-1V19a1 1 0 00-1-1H11zm26-2H11a3 3 0 00-3 3v16a3 3 0 003 3h26a3 3 0 003-3V19a3 3 0 00-3-3zm-18 .594a1 1 0 00-1 1V26h-8a1 1 0 000 2h8v8.331a1 1 0 102 0v-8.33h8v8.33a1 1 0 002 0v-8.33h8a1 1 0 000-2h-8v-8.407a1 1 0 10-2 0V26h-8v-8.406a1 1 0 00-1-1z",
    fill: "currentColor"
  }));
};

var SvgCalendar = styled(SvgComponent).withConfig({
  displayName: "Calendar__SvgCalendar",
  componentId: "sc-1dofyeb-0"
})(["", " ", ""], size, color);
export default SvgCalendar;